'use client'

import AnimatedSection from '@/components/AnimatedSection'
import Main from './_blocks/Main'
import ApplicationOverview from './_blocks/ApplicationOverview'
import Advantages from './_blocks/Advantages'
import ProcessAutomation from './_blocks/ProcessAutomation'
import B2bSolution from './_blocks/B2bSolution'
import Lending from './_blocks/Lending'
import CtaBanner from './_blocks/CtaBanner'
import ReadySolution from './_blocks/ReadySolution'
import Tariff from './_blocks/Tariff'
import Clients from '@/app/services/_blocks/Clients'
import Portfolio from '@/app/portfolio/[portfolio]/_blocks/Portfolio'
import Contact from '@/app/_blocks/Main_redesign/Contact'
import styles from './styles.module.css'

const Page = () => {
	return (
		<article className={styles.content}>
			<Main />
			<div className={styles.whiteBlock}>
				<ApplicationOverview />
			</div>
			<Advantages />
			<ProcessAutomation />
			<div className={styles.whiteBlock}>
				<B2bSolution />
			</div>
			<Lending />
			<AnimatedSection animation='slideUp'>
				<div className={styles.ctaBannerBlock}>
					<CtaBanner />
				</div>
			</AnimatedSection>
			<ReadySolution />
			<Tariff />
			<AnimatedSection animation='slideUp'>
				<div className={styles.clientsBlock}>
					<Clients />
				</div>
			</AnimatedSection>
			<AnimatedSection animation='slideUp'>
				<div className={styles.portfolioBlock}>
					<Portfolio />
				</div>
			</AnimatedSection>
			<AnimatedSection animation='slideUp'>
				<div className={styles.contactBlock}>
					<Contact />
				</div>
			</AnimatedSection>
		</article>
	)
}

export default Page

/*
 * ============================================================================
 * СТАРАЯ ВЕРСИЯ СТРАНИЦЫ B2B (закомментирована, не удалять).
 * Использовала блоки из src/blocks_fintech/*.
 * Новая версия выше построена по образцу страницы b2c.
 * ----------------------------------------------------------------------------
 *
 * import FAQ from '@/blocks_fintech/Faq/Faq'
 * import FeaturesIcons from '@/blocks_fintech/FeaturesIcons/FeaturesIcons'
 * import GradientForm from '@/blocks_fintech/GradientForm/GradientForm'
 * import HeroSection from '@/blocks_fintech/HeroSection/HeroSection'
 * import InterfaceSlider from '@/blocks_fintech/InterfaceSlider/InterfaceSlider'
 * import PricingTable from '@/blocks_fintech/PricingTable/PricingTable'
 * import ProductInfo from '@/blocks_fintech/ProductInfo/ProductInfo'
 * import SliderSteps from '@/blocks_fintech/SliderSteps/SliderSteps'
 * import AnimatedSection from '@/components/AnimatedSection'
 * import styles from './styles.module.css'
 *
 * const Page = () => {
 * 	return (
 * 		<article>
 * 			<section className={styles.content}>
 * 				<AnimatedSection animation="slideUp">
 * 					<HeroSection />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<FeaturesIcons />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<ProductInfo />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<SliderSteps />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<InterfaceSlider />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<PricingTable />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<GradientForm />
 * 				</AnimatedSection>
 * 				<AnimatedSection animation="slideUp">
 * 					<FAQ />
 * 				</AnimatedSection>
 * 			</section>
 * 		</article>
 * 	)
 * }
 *
 * export default Page
 * ============================================================================
 */
